import { ImageGravity } from '@shared/components/image/models';

/**
 * Computes and returns a gravity string based on the provided ImageGravity object.
 * This string is typically used for image transformations in a CDN or similar service.
 *
 * @param gravity - Object containing the x, y, width, and height properties.
 * @returns A string including the gravity values (x, y) formatted for image transformations.
 */
export const getGravity = (gravity: ImageGravity): string => {
  // Round a numeric value to two decimal places
  const round = (value: number): number => Math.round(value * 100) / 100;

  // Local reference to the gravity object
  const g = gravity;

  // Calculate the gravity using the position (x, y) relative to width and height
  // The expression "1 - (g.width - g.x) / g.width" converts the x coordinate
  // to a 0–1 range, and similarly for y.
  return `gravity=${round(1 - (g.width - g.x) / g.width)}x${round(1 - (g.height - g.y) / g.height)}`;
};
